import {TwoGirlsStandingTogether} from "../../../../assets";

export default function CarouselCard13() {

    return (
        <div
            className="swiper-slide content-slide"
            data-title="Alumni">
            <div
                className="row align-items-start align-items-lg-center">
                <div
                    className="col-6 col-lg-auto position-relative d-flex flex-wrap gap-3">
                    <img
                        className="polaroid img-fluid"
                        src={TwoGirlsStandingTogether}
                        alt="Extern Academy Alumni"/>

                    <img
                        className="polaroid img-fluid"
                        src="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/editorial/https-3a-2f-2fdev-to-uploads-s3-amazonaws-com-2fuploads-2far.webp"
                        alt="Y Combinator Logo"/>
                </div>
                <div className="col-6 col-lg">
                    <h5> Alumni Journey</h5>
                    <p><span
                        style={{whiteSpace: 'pre-wrap'}}>
                        Our alumni are not just former students; they’re lifelong members of a tight-knit community. Even after the program ends, they stay connected — returning to share words of wisdom with current externs and give back to the community that shaped them.</span>
                    </p>
                    <div
                        className="d-flex flex-wrap gap-3">
                        <a href="/stories/next-big-thing"
                           className="text-uppercase btn btn-primary">
                            The Journey
                            Continues </a>
                    </div>
                </div>
            </div>
        </div>
    )
}